const PageNotFound = () => {
  return (
    <div className="px-8 text-center w-full">
      <h1 className="text-4xl">404 Error</h1>
      <h1 className="text-4xl mt-3">Page Not Found</h1>
    </div>
  );
};

export default PageNotFound;
